import { DefaultOptionType } from "antd/es/select";
import { Dayjs } from "dayjs";
import { DataPair, DocumentApi } from "../../../types";
import { FilterSelectOption } from "../../filters/filters.types";

export interface IInformacijeZaVracanjeMarkica {
  kategorijaProizvodaId: number | null;
  tipObveznikaIds: number[];
}

export interface IInostraniProizvodjac {
  naziv: string;
  poreskiBroj: string;
  adresa: string;
  mesto: string;
}

export interface IDistributer {
  naziv: string;
  poreskiBroj: string;
  adresa: string;
  mesto: string;
}

export interface IPodaciOTrazenimMarkicama {
  markicaKategorijaVrsteId: number | null;
  markicaVrstaPakovanjaId: number | null;
  kolicina: number | null;
  isporuceniOpsezi?: Array<{
    isporuceniOpsegOd: string;
    isporuceniOpsegDo: string;
  }>;
  nedostajuceVrednosti?: string;
  tipPakovanjaId: number | null;
}

export interface IPodaciOTrazenimMarkicamaPrint {
  markicaKategorijeVrsteIme: string;
  markicaKategorijeVrsteId: number | null;
  pakovanjeOpis: string;
  kolicina: number | null;
  isporuceniOpsezi: Array<{
    isporuceniOpsegOd: string;
    isporuceniOpsegDo: string;
  }>;
  nedostajuceVrednosti: string;
  tipPakovanja: string;
  tipPakovanjaShow: boolean;
  pakovanjeOznaka?: string;
}

export interface IKreiranjeZahtevaZaMarkicuPayload {
  id?: number;
  brojPorudzbenice: string | null;
  markicaKategorijaId: number | null;
  tipObveznikaIds: number[];
  inostraniProizvodjac?: IInostraniProizvodjac;
  distributer?: IDistributer;
  adresaSlanjaMarkica: string;
  podaciOTrazenimMarkicama: IPodaciOTrazenimMarkicama[];
  dokumentSpecifikacija: DocumentApi | null;
}

export interface ExciseStampRequestListPayload {
  brojZahteva: string | null;
  brojMarkice: string | null;
  datum: string | null | Dayjs;
  vrstaProizvoda: number | null;
  statusZahteva: number | null;
}

export interface ExciseStampRequestListResponse {
  exciseStampRequestList: ExciseStampRequest[];
  productTypes: DefaultOptionType[];
  statuses: DefaultOptionType[];
}
export interface ITipObveznika {
  tipObveznikaId: number | null;
  imeTipaObveznika: string;
}

export interface IKategorijeProizvodaProps {
  idKategorijeProizvoda: number | null;
  imeKategorijeProizvoda: string;
  tipObveznika: ITipObveznika[];
}

export interface IVrstaProizvodaProps {
  id: number | null;
  naziv: string;
}
export interface IInicijalniPodaciZaZahtevObveznikaProps {
  kategorijaProizvoda: IKategorijeProizvodaProps[];
  vrstaProizvoda: IVrstaProizvodaProps[];
}

export interface IOvlascenaLicaZaPreuzimanjeMarkicaProps {
  id: number | null;
  imeIPrezime: string;
  brojLicneKarte: string;
}

export interface IOvlascenaLicaZaPreuzimanjeMarkicaEncodedProps {
  id: number | null;
  imeIPrezime: string;
  encodedBrlk: string;
}

export interface IDrustvoInformationMarkiceZahtevProps {
  id: number | null;
  naziv: string;
  imeGrada: string;
  adresa: string;
  pib: string;
  maticniBroj: string;
  imeIPrezimeKontaktOsobe: string;
  emailAdresaKontaktOsobe: string;
  jmbgKontaktOsoba: string;
  brojTekucegRacuna: string[];
  preteznaDelatnost: string;
  emailAdresa: string;
  postanskiBroj: string;
  imeDrzave: string;
  ovlascenaLicaZaPreuzimanjeMarkica: IOvlascenaLicaZaPreuzimanjeMarkicaEncodedProps[];
}

export interface IKategorijaZaZahtevProps {
  markicaKategorijaVrsteId: number | null;
  markicaKategorijeVrsteIme: string;
  preselectedTipPakovanjaIds: number[] | null;
  tipoviPakovanjaZaVrstuKategorije?: Array<TipPakovanjaVrsteKategorije> | null;
}

export interface MarkicaZahtevIsporuceniOpsezi {
  markicaKategorijaVrsteId: number | null;
  markicaKategorijeVrsteIme: string;
  preselectedTipPakovanjaIds: number[] | null;
  showAmbalaza: boolean;
  opsezi: Array<{ id: number; opseg: string }>;
}

export interface IPakovanjeZaZahtevProps {
  pakovanjeId: number | null;
  pakovanjeOpis: string;
}

export interface TipPakovanja {
  id: number;
  naziv: string;
  minimalnaKolicina: number;
}

export interface IKategorijeZaZahtevProps {
  kategorijaZaZahtev: IKategorijaZaZahtevProps[];
  pakovanjaZaZahtev: IPakovanjeZaZahtevProps[];
  tipPakovanja: Array<TipPakovanja>;
  tipPakovanjaShow: boolean;
}

export interface IVracanjeDodatnihInformacijaZaKreiranjeZahtevaProps {
  drustvoInformationMarkiceZahtev: IDrustvoInformationMarkiceZahtevProps;
  isUvoznik: boolean;
  kategorijeZaZahtev: IKategorijeZaZahtevProps;
  prikaziMaloprodajneCene: boolean;
  isPP: boolean;
}

export interface IMarkicaZahteviDrustvoInfoDtoProps {
  naziv: string;
  imeGrada: string;
  adresa: string;
  pib: string;
  maticniBroj: string;
  brojTekucegRacuna: string[];
  preteznaDelatnost: string;
  ovlascenaLicaZaPreuzimanjeMarkica: IOvlascenaLicaZaPreuzimanjeMarkicaEncodedProps[];
}

export interface IKategorijaVrstaZahtevaDtoProps {
  markicaKategorijeVrsteIme: string;
  markicaKategorijeVrsteId: number;
  pakovanjeId: number | null;
  zahtevTrazeneMarkiceId: number;
  pakovanjeOznaka: string;
  kolicina: number | null;
  isporuceniOpsezi: Array<{
    isporuceniOpsegOd: string | null;
    isporuceniOpsegDo: string | null;
  }>;
  nedostajuceVrednosti: string[] | null;
  tipPakovanja: string | null;
  tipPakovanjaShow: boolean;
}

export interface IZahtevZaMarkicuUvoznikProps {
  inostraniProizvodjacNaziv: string;
  inostraniProizvodjacPoreskiBroj: string;
  inostraniProizvodjacAdresa: string;
  inostraniProizvodjacMesto: string;
  distributerInostranogProizvodjacaNaziv: string;
  distributerInostranogProizvodjacaPoreskiBroj: string;
  distributerInostranogProizvodjacaAdresa: string;
  distributeraInostranogProizvodjacaMesto: string;
  distributerInostranogProizvodjacaAdresaSlanjaMarkica: string;
}

export interface IMarkicaZahtevStatusiProps {
  odobren: number | null;
  odbijen: number | null;
  vracenNaDopunu: number | null;
}

export interface NapravljenZahtevZaMarkicu {
  brojPorudzbenice: string;
  markicaZahteviDrustvoInfoDto: IMarkicaZahteviDrustvoInfoDtoProps;
  isUvoznik: boolean;
  stampajPredracun: boolean;
  isPlacen: boolean;
  evidencioniBroj: string;
  isVracenNaDopunu: boolean;
  statusZahteva: string;
  imaPakovanje: boolean;
  showNedostajuceVrednosti: boolean;
  kategorijaVrstaZahtevaDto: IKategorijaVrstaZahtevaDtoProps[];
  markicaZahtevStatusNotes: string[];
  zahtevZaMarkicuUvoznik: IZahtevZaMarkicuUvoznikProps;
  markicaZahtevStatusi: IMarkicaZahtevStatusiProps;
  tipObveznikaIds: number[];
  kategorijaProizvodaId: number;
  tipPakovanja?: string;
  datumIsporuke: string | null;
  dokumentSpecifikacija: DataPair | null;
}

export interface ExciseStampRequest {
  id: number | null;
  brojZahteva: string;
  vrstaProizvoda: string;
  datumKreiranjaZahteva: string;
  opsegIsporucenihMarkica: string[];
  status: string;
  vracenNaDopunu: boolean;
}

export interface IZahtevMarkiceIdProps {
  zahtevMarkicaId: number | null;
}

export interface IGenerisiZahtevZaMarkicuPdfProps {
  content: string;
}

export interface ISviZahteviMarkiceProps {
  filters: FilterSelectOption[];
  vrsteFilters: FilterSelectOption[];
  markiceZahtevi: ExciseStampRequest[];
}

export interface IFilterProizvodaProps {
  pageNumber: number | null;
  pageSize: number | null;
}

export interface IPodaciOMarkamaProizvodaPayload {
  markicaKategorijeId: number | null;
  filter: IFilterProizvodaProps;
}

export interface IPodaciOMarkamaProizvodaProps {
  sifra: string;
  naziv: string;
}

export interface IResultsProps {
  result: IPodaciOMarkamaProizvodaProps[];
  totalCount: number;
}

export interface IResultProps {
  nazivMarke: string;
  maloprodajnaCena: number | null;
  brojSluzbenogGlasnika: string;
  datumObjave: string;
  datumOdKadaVaziCena: string;
}

export interface IMaloProdajnaProps {
  result: IResultProps[];
  totalCount: number;
}

export interface IFilterMaloprodajeProps {
  marka: string | null;
  datumVazenjaOd: string | null;
  datumVazenjaDo: string | null;
  pageNumber: number | null;
  pageSize: number | null;
}

export interface IMaloProdajnaPayload {
  markicaKategorijeId: number | null;
  filter: IFilterMaloprodajeProps;
}

export interface IStampajPredracunProps {
  content: string;
}

export interface IPopuniIzvestajZaKafuIliAlkoholPayload {
  datumDo: string | null;
  isCoffee: boolean | null;
  brojIDatumZahteva: string;
  slovneOznakeIKolicinaPreuzetihMarkica: string;
  oznakaSerijeISerijskiBrojPreuzetihMarkica: string;
  brojNerazduzenihMarkicaPrethodniKvartal: number | null;
  brojIskoriscenihMarkicaIzProizvodnje: number | null;
  brojIskoriscenihMarkicaIzUvoza: number | null;
  ambalazaIzUvoza: number | null;
  brojOstecenihVidljivihMarkica: number | null;
  brojOstecenihNevidljivihMarkica: number | null;
  brojNerazduzenihMarkicaISerijskiBrojNaKraju: string;
}

export interface ISviPrihvatanjeKodovaProps {
  drustvoIme: string;
  paleta: IContent2Props[];
  masterCase: IContent2Props[];
  boks: IContent2Props[];
  kodovi: IContent2Props[];
}

export interface IContent2Props {
  naziv: string;
  drustvoSaKogSeSalje: string;
  objekatSaKogSeSaljePrima: string;
  napomena: string;
  id: number | null;
  objekat: string;
  isOpoziv: boolean;
  isDeaktiviran: boolean;
  datum: string;
  children: IContent2Props[];
}

export interface IContentProps {
  naziv: string;
  id: number | null;
  objekatSaKogSeSalje: string;
  drustvoKojePrima: string;
  napomena: string;
  voziloSlanje: string;
  pretovar: string;
  isOpoziv: boolean;
  isDeaktiviran: boolean;
  objekatKojiPrima: string;
  datum: string;
  children: IContentProps[];
}

export interface ISviSlanjaKodovaProps {
  drustvoIme: string;
  paleta: IContentProps[];
  masterCase: IContentProps[];
  boks: IContentProps[];
  kodovi: IContentProps[];
}

export interface ISviSlanjaKodovaResponse {
  data: ISviSlanjaKodovaProps;
  success: boolean;
  errorMessage: string;
}

export interface ISviPrihvatanjeKodovaResponse {
  data: ISviPrihvatanjeKodovaProps;
  success: boolean;
  errorMessage: string;
}

export interface IDetaljiTabelaPayload {
  tipId: number | null;
  id: number | null;
}

export interface ExciseStampsState {
  //Response for inicijalniPodaciZaZahtevObveznika

  kategorijaProizvoda: IKategorijeProizvodaProps[];
  vrstaProizvoda: IVrstaProizvodaProps[];

  //Response for vracanjeDodatnihInformacijaZaKreiranjeZahteva

  drustvoInformationMarkiceZahtev: IDrustvoInformationMarkiceZahtevProps;
  isUvoznik: boolean;
  kategorijeZaZahtev: IKategorijeZaZahtevProps;
  prikaziMaloprodajneCene: boolean;
  isPP: boolean;

  //Response for kreiranjeZahtevaZaMarkicu

  zahtevMarkicaId: number | null;

  //Payload for kreiranjeZahtevaZaMarkicu

  brojPorudzbenice: string;
  kategorijaProizvodaId: number | null;
  tipObveznikaIds: number[];
  inostraniProizvodjac: IInostraniProizvodjac;
  distributer: IDistributer;
  adresaSlanjaMarkica: string;
  podaciOTrazenimMarkicama: IPodaciOTrazenimMarkicama[];
  dokumentSpecifikacija: DocumentApi | null;

  //Response for informacijeNapravljenogZahtevaZaMarkicu

  markicaZahteviDrustvoInfoDto: IMarkicaZahteviDrustvoInfoDtoProps;
  kategorijaVrstaZahtevaDto: IKategorijaVrstaZahtevaDtoProps[];
  imaPakovanje: boolean;
  showNedostajuceVrednosti: boolean;
  stampajPredracun: boolean;
  statusZahteva: string;
  isVracenNaDopunu: boolean;
  markicaZahtevStatusNotes: string[];
  zahtevZaMarkicuUvoznik: IZahtevZaMarkicuUvoznikProps;
  markicaZahtevStatusi: IMarkicaZahtevStatusiProps;
  dokumentSpecifikacijaDetails: DataPair | null;
  //Response for podaciOMarkamaProizvoda

  podaciOMarkamaProizvoda: IPodaciOMarkamaProizvodaProps[];

  //Response for maloprodajneCeneMarkiProizvoda

  maloprodajneCeneMarkiProizvoda: IResultProps[];

  //SelectedStamps

  podaciOTrazenimMarkicamaPrint: IPodaciOTrazenimMarkicamaPrint[];
  selectedVrstaAkcizneMarkiceIme: string;
  selectedOznakaPakovanjaOpis: string;
  selectedVrstaAkcizneMarkiceId: number | null;
  selectedOznakaPakovanjaId: number | null;
  tipPakovanjaId: number | null;
  tipPakovanja: string;
  tipPakovanjaShow: boolean;
  selectedTrazeneKolicine: string;
  selectedMarkicaId: number | null;
  isporuceniOpsezi: Array<{
    isporuceniOpsegOd: string;
    isporuceniOpsegDo: string;
  }>;
  selectedNedostajuceVrednosti: string;
  evidencioniBroj: string;
  isOpseg: boolean;

  isDistributerRequired: boolean;
  isProizvodjacRequired: boolean;
  datumIsporuke: string | null;
}

export type UpdateStampsFunction = (
  updatedState: Partial<ExciseStampsState>
) => void;

export type RequestedStampsInfoTableColumnName =
  | "markicaKategorijeVrsteIme"
  | "opseg"
  | "kolicina"
  | "tipPakovanja"
  | "pakovanjeOznaka"
  | "nedostajuceVrednosti";

export enum AkciznaMarkicaKategorijaProzivoda {
  ALKOHOL = 1,
  DUVAN,
  KAFA,
  DERIVATI_NAFTE,
}

export enum TipObveznika {
  PROIZVODJAC = 1,
  UVOZNIK,
  VELETRGOVINA,
  MALOPRODAJA,
  POSEBNI_POSTUPAK,
}

export interface TipPakovanjaVrsteKategorije {
  tipPakovanjaId: number;
  tipPakovanjaNaziv: string;
}
